import { Component, OnInit } from '@angular/core';
import { Globals } from '../../globals';
import { Router } from '@angular/router';

@Component({
  selector: 'app-precio-tipo',
  templateUrl: './precio-tipo.component.html',
  styleUrls: ['./precio-tipo.component.scss']
})
export class PrecioTipoComponent implements OnInit {

  constructor(
    public globals: Globals,
    private router: Router,
  ) { }

  seleccionarMayor(){
    this.globals.configuracion.front.typeabbrev = "02";
    this.globals.setDataFront();

    this.router.navigate(['/catalogo']);
  }

  seleccionarDetal(){
    this.globals.configuracion.front.typeabbrev = "01";
    this.globals.setDataFront();

    this.router.navigate(['/marcas']);
  }

  ngOnInit(): void {
    this.globals.configuracion.front.listado.marca = '';
    this.globals.configuracion.front.listado.modelo = '';
    this.globals.setDataFront();
  }

}

